// extracted by mini-css-extract-plugin
export default {"photo_list":"PhotoList_photo_list__dWl2v"};